import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { OptionsComponent } from './options.component';


const routes: Routes = [
  {
    path: 'options',
    component: OptionsComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class OptionsRoutingModule {}
